// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.frontpage {
  width: 100%;
  overflow-x: hidden;
  position: relative;
}

.section-visible {
  opacity: 1 !important;
  transform: translateY(0) !important;
}

@media (max-width: 768px) {
  .flipbook-section {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/frontpage/FrontPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":[".frontpage {\n  width: 100%;\n  overflow-x: hidden;\n  position: relative;\n}\n\n.section-visible {\n  opacity: 1 !important;\n  transform: translateY(0) !important;\n}\n\n@media (max-width: 768px) {\n  .flipbook-section {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
